import React, { useState } from 'react'
import { getImages } from '../../../const'
import { Link, NavLink } from 'react-router-dom'
import MenuList from './MenuList';
import HeaderActions from './HeaderActions';

const Header = () => {
    const [isMob, setisMob] = useState(false);
    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.removeAttribute('class');
    };
    const [openSubMenu, setOpenSubMenu] = useState(false)
    const handleSubMenu = (menu) => {
        setOpenSubMenu((prevMenu) => (prevMenu === menu ? null : menu));
    }
    const closeMenu = () => {
        setisMob(false);
        setOpenSubMenu(false);
        document.body.classList.remove('overflow-active');
    }
    const hoverHandleSubMenu = (menu) => {
        if (window.innerWidth > 1200) {
            setOpenSubMenu((prevMenu) => (prevMenu === menu ? null : menu));
        }
    }
    const [isHoveringMenu, setIsHoveringMenu] = useState(false);
  return (
    <>
        <header className='header-wrap'>
            <div className='container-fluid'>
                <div className='d-flex align-items-center'>
                    <div className='main-logo'>
                        <Link to='/'><img src={getImages('WeGoScenic-logo.png')}/></Link>
                    </div>
                    {/* <div className={`position-relative ms-xl-5 ps-xl-5 main-menu ${isMob ? 'active' : ''}`}>
                        <MenuList closeMenu={closeMenu}/>
                    </div> */}
                    <div className='d-none d-sm-flex ms-md-auto align-items-center'>
                        <HeaderActions/>
                    </div>
                    {/* <div className={`overflow-bg d-xl-none ${isMob ? 'active' : ''
                        }`} onClick={() => onChangeBodyClass(!isMob)}></div>
                    <div
                        className={`mobile-inner-header ms-3 d-xl-none ${isMob ? 'active' : ''}`}
                        onClick={() => onChangeBodyClass(!isMob)}
                    >
                        <div
                            className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                }`}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div> */}
                </div>
            </div>
        </header>
    </>
  )
}

export default Header